import SaveIcon from "@mui/icons-material/Save";
import { LoadingButton } from "@mui/lab";
import { Alert, Snackbar, Tooltip, useTheme } from "@mui/material";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import { enUS, zhTW } from "date-fns/locale";
import React, {
  forwardRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { marketplaceContext } from "../../contexts/MarketplaceContext/index";
import { useAppSelector } from "../../hooks";
import useListNft from "../../hooks/useListNft";
import {
  decodeCurrency,
  decodeListPrice,
  decodeListUrl,
} from "../../utils/format.utils";
import "./index.css";

interface Props {
  handleClose: () => void;
  buyModalstatus: any;
}

const Form: React.FC<Props & { ref?: React.Ref<any> }> = forwardRef(
  (props, ref) => {
    const { handleClose, buyModalstatus } = props;
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const { currentAddress } = useAppSelector((state) => state.auth);
    const [isApprove, setIsApprove] = useState(0);
    const [isProcessing, setIsProcessing] = useState(false);
    const [openalert, setOpenalert] = React.useState(false);
    const [switching, setSwitching] = React.useState(false);
    const chainIdError = useRef(false);
    const [alertString, setAlertString] = useState("");
    const isMountedRef = useRef(false);
    const { chainId } = useContext(marketplaceContext);
    const [copytext, setCopytext] = useState("");
    const copyToClipboard = (source: string) => {
      const copiedText = document.createElement("input");
      document.body.appendChild(copiedText);
      copiedText.setAttribute("value", source);
      copiedText.select();
      document.execCommand("copy");
      document.body.removeChild(copiedText);
    };
    console.log(buyModalstatus.data.detail.chain_id);
    const clickCopy = (source: string) => {
      copyToClipboard(source);
      setCopytext(t("Message_Item_Copytext"));
      setTimeout(() => {
        setCopytext("");
      }, 1300);
    };
    const handleError = () => {
      setOpenalert(true);
      setTimeout(handleAlert, 5000);
    };
    const handleAlert = () => {
      setOpenalert(false);
    };
    const {
      buyNFT,
      buyDmNFT,
      approveERC20,
      isApproveERC20,
      delistNFT,
      delistDmNFT,
      switchChainId,
    } = useListNft();
    const handleSubmit = async (e: React.SyntheticEvent) => {
      setIsProcessing(true);
      e.preventDefault();
      console.log("buy loading start");
      try {
        await switchChainId(buyModalstatus.data.detail.chain_id);
        if (buyModalstatus.type == "dm") {
          let transaction = await buyDmNFT(
            buyModalstatus.data.detail.message_id
          );
          const transactionReceipt = await transaction.wait();
          if (transactionReceipt.status == 1) {
            console.log("buy tx end");
          } else {
            console.log("buy tx error");
          }
        } else {
          let transaction = await buyNFT(buyModalstatus.data.detail.message_id);
          const transactionReceipt = await transaction.wait();
          if (transactionReceipt.status == 1) {
            console.log("buy tx end");
          } else {
            console.log("buy tx error");
          }
        }
        console.log("buy loading end");
        handleClose();
      } catch (err) {
        console.log("buy tx error");
        setAlertString(t("List_Nft_Buy_Fail"));
        handleError();
        console.log(err);
      } finally {
        setIsProcessing(false);
      }
    };
    const handleApprove = async (e: React.SyntheticEvent) => {
      setIsProcessing(true);
      e.preventDefault();
      console.log("approve loading start");
      try {
        await switchChainId(buyModalstatus.data.detail.chain_id);
        let transaction = await approveERC20(
          buyModalstatus.data.detail.typeddata.calculationItem[0].token
        );
        const transactionReceipt = await transaction.wait();
        if (transactionReceipt.status == 1) {
          let result = await isApproveERC20(
            buyModalstatus.data.detail.typeddata.calculationItem[0].token
          );
          setIsApprove(result.detail);
        } else {
          console.log("approve tx error");
        }
        console.log("approve loading end");
      } catch (err) {
        console.log("approve tx error");
        setAlertString(t("List_Nft_Approve_Fail"));
        handleError();
        console.log(err);
      } finally {
        setIsProcessing(false);
      }
    };
    const handleDelist = async (e: React.SyntheticEvent) => {
      setIsProcessing(true);
      e.preventDefault();
      console.log("delist loading start");
      try {
        await switchChainId(buyModalstatus.data.detail.chain_id);
        if (buyModalstatus.type == "dm") {
          let transaction = await delistDmNFT(
            buyModalstatus.data.detail.message_id
          );
          const transactionReceipt = await transaction.wait();
          if (transactionReceipt.status == 1) {
            console.log("delist tx end");
          } else {
            console.log("delist tx error");
          }
        } else {
          let transaction = await delistNFT(
            buyModalstatus.data.detail.message_id
          );
          const transactionReceipt = await transaction.wait();
          if (transactionReceipt.status == 1) {
            console.log("delist tx end");
          } else {
            console.log("delist tx error");
          }
        }
        console.log("delist loading end");
        handleClose();
      } catch (err) {
        console.log("delist tx error");
        setAlertString(t("List_Nft_DeList_Fail"));
        handleError();
        console.log(err);
      } finally {
        setIsProcessing(false);
      }
    };
    const handleSwitch = async (e: React.SyntheticEvent) => {
      setIsProcessing(true);
      e.preventDefault();
      try {
        await switchChainId(buyModalstatus.data.detail.chain_id);
      } catch (err) {
        setAlertString(t("List_Nft_Switch_Fail"));
        handleError();
        console.log(err);
      } finally {
        setIsProcessing(false);
      }
    };
    const getLocale = () => {
      if (i18n.language === "zh-TW") return zhTW;
      return enUS;
    };
    useEffect(() => {
      (async () => {
        let result = await isApproveERC20(
          buyModalstatus.data.detail.typeddata.calculationItem[0].token
        );
        setIsApprove(result.detail);
      })();
    }, [
      buyModalstatus.data.detail.typeddata &&
        buyModalstatus.data.detail.typeddata.calculationItem[0].token,
    ]);
    useEffect(() => {
      (async () => {
        try {
          if (isMountedRef.current == false) {
            setSwitching(true);
            isMountedRef.current = true;
            await switchChainId(buyModalstatus.data.detail.chain_id);
            setSwitching(false);
            isMountedRef.current = false;
          }
        } catch (err) {
          setSwitching(false);
          isMountedRef.current = false;
        }
      })();
    }, []);
    useEffect(() => {
      if (parseInt(buyModalstatus.data.detail.chain_id) != chainId) {
        chainIdError.current = true;
        setAlertString(t("List_Nft_Chain_Id_Error"));
        setOpenalert(true);
      } else {
        chainIdError.current = false;
        handleAlert();
      }
    }, [chainId]);

    return (
      <form
        ref={ref}
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "2rem",
          overflow: "scroll",
        }}
      >
        <Snackbar
          open={openalert}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            variant="filled"
            severity="error"
            color="error"
            onClose={handleAlert}
          >
            <strong>{alertString}</strong>
          </Alert>
        </Snackbar>
        <div className="nft-buy-modal-title">
          {buyModalstatus.data.detail.offerer == currentAddress
            ? t("List_Nft_Modal_Title_View")
            : isApprove >= buyModalstatus.data.detail.price
            ? t("List_Nft_Modal_Title_Buy")
            : t("List_Nft_Modal_Title_Approve")}
        </div>
        <div className="nft-buy-modal-card">
          <Tooltip
            title={
              t("List_Nft_Visit_NFT") +
              " " +
              decodeListUrl(buyModalstatus.messageText).split(",")[1] +
              copytext
            }
            placement="bottom-start"
            disableInteractive
            followCursor
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  width: "210px",
                },
              },
            }}
          >
            <div
              className="nft-buy-modal-card-img"
              onClick={() => {
                clickCopy(
                  decodeListUrl(buyModalstatus.messageText).split(",")[1]
                );
              }}
            >
              <img
                src={decodeListUrl(buyModalstatus.messageText).split(",")[0]}
              />
            </div>
          </Tooltip>
          <div className="nft-buy-modal-card-info">
            <div className="nft-buy-modal-card-info-item">
              <div className="nft-buy-modal-card-info-label">
                {t("List_Nft_Expire_In")}
              </div>
              <div className="nft-buy-modal-card-info-price">
                {formatDistanceToNow(
                  new Date(buyModalstatus.data.detail.endTime),
                  { locale: getLocale() }
                )}
              </div>
            </div>
            <div className="nft-buy-modal-card-info-item">
              <div className="nft-buy-modal-card-info-label">
                {t("List_Nft_Price")}
              </div>
              <div className="nft-buy-modal-card-info-price">
                {decodeListPrice(
                  buyModalstatus.data.detail.price,
                  buyModalstatus.data.detail.currency
                )}{" "}
                {decodeCurrency(
                  buyModalstatus.data.detail.currency,
                  buyModalstatus.data.detail.chain_id
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="nft-buy-modal-buttons">
          {switching ? (
            <LoadingButton
              color="secondary"
              loading={true}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
            >
              <span>{t("List_Nft_Switching")}</span>
            </LoadingButton>
          ) : chainIdError.current ? (
            <LoadingButton
              className="nft-buy-modal-button-buy"
              onClick={handleSwitch}
              loading={isProcessing}
              variant="contained"
              sx={{ backgroundColor: theme.brandColor, color: "#fff" }}
            >
              {t("List_Nft_Button_SWITCH")}
            </LoadingButton>
          ) : buyModalstatus.data.detail.offerer == currentAddress ? (
            <span>
              <LoadingButton
                className="nft-buy-modal-button-buy"
                onClick={handleDelist}
                loading={isProcessing}
                variant="contained"
                sx={{ backgroundColor: theme.brandColor, color: "#fff" }}
              >
                {t("List_Nft_Button_Delist")}
              </LoadingButton>
            </span>
          ) : isApprove >= buyModalstatus.data.detail.price ? (
            <LoadingButton
              className="nft-buy-modal-button-buy"
              onClick={handleSubmit}
              loading={isProcessing}
              variant="contained"
              sx={{ backgroundColor: theme.brandColor, color: "#fff" }}
            >
              {t("List_Nft_Button_Buy")}
            </LoadingButton>
          ) : (
            <LoadingButton
              className="nft-buy-modal-button-buy"
              onClick={handleApprove}
              loading={isProcessing}
              variant="contained"
              sx={{ backgroundColor: theme.brandColor, color: "#fff" }}
            >
              {t("List_Nft_Button_Approve")}
            </LoadingButton>
          )}
          {!switching ? (
            <button
              className="nft-buy-modal-button-cancel"
              onClick={handleClose}
            >
              {t(
                buyModalstatus.data.detail.offerer == currentAddress
                  ? "List_Nft_Button_Close"
                  : "List_Nft_Button_Cancel"
              )}
            </button>
          ) : (
            <></>
          )}
        </div>
      </form>
    );
  }
);

export default Form;
